import PaginatedReportsTab from '../../components/paginated-reports-tab';

export default function ReportsTab() {
  return (
    <PaginatedReportsTab
      reportType="collectibles"
      benefitCountLabel="Quantidade de coleções"
      errorLabel="colecionáveis"
    />
  );
}
